import { Controller } from "@hotwired/stimulus"
import axios from "axios"

// Drag&drop kolejności zaznaczonych kolumn w dropdownie konfiguracyjnym tabeli.
// Współpracuje z partialem `components/tailwind/_table_settings_dropdown.html.erb`.
// Tylko zaznaczone (visible) wiersze mają drag-handle — odznaczone nie biorą udziału.
// Po upuszczeniu zbieramy data-key z aktualnej kolejności DOM-u i zapisujemy
// pełną tablicę do `user_setting.fields.<keyValue>` przez /account/set_field.
//
// Wymagane data-attributes na elemencie z controllerem:
//   data-controller="columns-reorder"
//   data-columns-reorder-save-url-value="<%= account_set_field_path %>"
//   data-columns-reorder-key-value="<dot.path.like.crm.clients.columns>"
//   data-action="dragstart->... dragover->... drop->... dragend->..."
export default class extends Controller {
  static targets = ["item"]
  static values = { saveUrl: String, key: String }

  dragstart(event) {
    const item = event.target.closest("[data-columns-reorder-target='item']")
    if (!item) {
      event.preventDefault()
      return
    }
    this.draggedItem = item
    event.dataTransfer.effectAllowed = "move"
    item.classList.add("opacity-40")
  }

  dragover(event) {
    if (!this.draggedItem) return
    event.preventDefault()

    const target = event.target.closest("[data-columns-reorder-target='item']")
    if (!target || target === this.draggedItem) return

    const rect = target.getBoundingClientRect()
    const insertBefore = event.clientY < rect.top + rect.height / 2
    if (insertBefore) {
      target.parentNode.insertBefore(this.draggedItem, target)
    } else {
      target.parentNode.insertBefore(this.draggedItem, target.nextSibling)
    }
  }

  drop(event) {
    event.preventDefault()
  }

  dragend() {
    if (!this.draggedItem) return
    this.draggedItem.classList.remove("opacity-40")
    this.draggedItem = null
    this.saveOrder()
  }

  saveOrder() {
    const newOrder = this.itemTargets.map((el) => el.dataset.key)

    axios.post(this.saveUrlValue, null, {
      params: {
        target: "user_setting",
        key: this.keyValue,
        value: JSON.stringify(newOrder)
      },
      headers: { Accept: "application/json" }
    }).catch((error) => {
      console.error("columns reorder save failed", error)
    })
  }
}
